import React, { useState, useRef } from "react";
import useTableScroll from "../../useTableScrollcesar";
import { Mensaje, MensajeSiNo } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import axios from "axios";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import { formatMoneda, validaSoloNumero } from "../../../util/varios";
import CatalogoComercio from "../../../catalogos/catalogoComercio";
import { DangerButton, SuccessButton } from "../../../ui/buttons/Button";
import { Input, SearchInput, Textarea } from "../../../ui/inputs/Input";

export const FacturaPublicidadPago = (props) => {
  moment.locale("es-us");

  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const [espiritu] = useState(localStorage.getItem("espiritu"));

  const txtContribuyente = useRef();
  const chkSeleccionarDeuda = useRef([]);

  const [idTipIngre, setIdTipIngre] = useState();
  const [idTipIngreMulta, setIdTipIngreMulta] = useState();
  const [nomTablaContri, setNomTablaContri] = useState();
  const [nomTabla, setNomTabla] = useState();
  const [tipoImpu, setTipoImpu] = useState();
  const [nomTablaDeuda, setNomTablaDeuda] = useState();
  const [idComercio, setIdComercio] = useState(0);
  const [factorCambio, setFactorCambio] = useState(0);

  const [disponiblesDeuda, setDisponiblesDeuda] = useState(0);
  const [catalogoC, setCatalogoC] = useState(false);
  const [cuentasBanca, setCuentasBanca] = useState("0");
  const [tabla] = useState(null);
  const [tipoPago, setTipoPago] = useState("");
  const [efectivo1, setEfectivo1] = useState("0,00");
  const [efectivo2, setEfectivo2] = useState("0,00");
  const [fechaD1, setFechaD1] = useState("");
  const [fechaD2, setFechaD2] = useState("");
  const [numeroD1, setNumeroD1] = useState("");
  const [numeroD2, setNumeroD2] = useState("");
  const [montoT1, setMontoT1] = useState("0,00");
  const [montoT2, setMontoT2] = useState("0,00");
  const [montoT3, setMontoT3] = useState("0,00");
  const [fechaT1, setFechaT1] = useState("");
  const [fechaT2, setFechaT2] = useState("");
  const [fechaT3, setFechaT3] = useState("");
  const [numeroT1, setNumeroT1] = useState("");
  const [numeroT2, setNumeroT2] = useState("");
  const [numeroT3, setNumeroT3] = useState("");
  const [banCliT1, setBanCliT1] = useState("0");
  const [banCliT2, setBanCliT2] = useState("0");
  const [banCliT3, setBanCliT3] = useState("0");

  const [titulo] = useState();
  const [msg] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [idcontribuyente] = useState(null);
  const [deuda, setDeuda] = useState([]);
  const [multa, setMulta] = useState([]);
  const [disabledMulta, setDisabledMulta] = useState(false);
  const [totalSelect, setTotalSelect] = useState({
    concepto: "",
    seleccionados: "",
    montoseleccionado: "",
    acrediSelect: "",
    montoFacturadoSelect: "",
    interesesSelect: "",
    multaSelect: "",
    recargoSelect: "",
    retenSelect: "",
  });
  const [valuess, setValuess] = useState({
    idcontribuyente: "",
    nombre: "",
    rif: "",
    direccion: "",
  });

  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");

  const headCells = [
    { label: "#", textAlign: "center" },
    { label: "Año", textAlign: "center" },
    { label: "Mes", textAlign: "center" },
    { label: "Descripción", textAlign: "left" },
    { label: "Ubicación", textAlign: "left" },
    { label: "Monto", textAlign: "right" },
  ];

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const onChange = (e) => {
    setValuess({ ...valuess, [e.target.name]: e.target.value });
    if (e.target.name === "idcontribuyente") {
      validaSoloNumero(e);
    }
  };

  const seleccionartipoIngreso = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "tipoimpuesto";
    let condi = "tipofacturacion = 2";
    let orden = "idtipoimpuesto";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(response.data);

          for (let i = 0; i < response.data.length; i++) {
            if (props.tipo === i) {
              setIdTipIngre(response.data[i].idtipoingreso);
              break;
            }
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionartipoIngresoMulta = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "tipoimpuesto";
    let condi = "tipofacturacion = 3";
    let orden = "idtipoimpuesto";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(response.data);

          for (let i = 0; i < response.data.length; i++) {
            setIdTipIngreMulta(response.data[i].idtipoingreso);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SelectDeuda = (id) => {
    let endpoint = "";
    let nomtab = "";
    let nomid = "";
    switch (props.tipo) {
      case 0:
        nomtab = "publicidad";
        nomid = "idcomercio";
        endpoint = `${op.conexion}/api/publicidad/consultadeuda?nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
        break;
      case 1:
        nomtab = "licores";
        nomid = "idcomercio";
        endpoint = `${op.conexion}/api/licores/deudalicores?nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
        break;
    }

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log("segunda consulta lista");

          var deu = [];
          //var his = [];
          for (let i = 0; i < response.data.length; i++) {
            var mm =
              response.data[i].fechainscripcion === null
                ? 0
                : parseInt(
                    moment.utc(response.data[i].fechainscripcion)
                      .format("YYYY-MM-DD")
                      .substring(5, 7)
                  );
            let mes = "";
            switch (mm) {
              case 1:
                mes = "ENERO";
                break;
              case 2:
                mes = "FEBRERO";
                break;
              case 3:
                mes = "MARZO";
                break;
              case 4:
                mes = "ABRIL";
                break;
              case 5:
                mes = "MAYO";
                break;
              case 6:
                mes = "JUNIO";
                break;
              case 7:
                mes = "JULIO";
                break;
              case 8:
                mes = "AGOSTO";
                break;
              case 9:
                mes = "SEPTIEMBRE";
                break;
              case 10:
                mes = "OCTUBRE";
                break;
              case 11:
                mes = "NOVIEMBRE";
                break;
              case 12:
                mes = "DICIEMBRE";
                break;
            }
            if (response.data[i].status === "Por Pagar") {
              switch (props.tipo) {
                case 0:
                  deu.push({
                    anio: response.data[i].anio,
                    mes: mes,
                    monto:
                      parseFloat(response.data[i].monto) *
                      parseFloat(factorCambio),
                    status: "Por Pagar",
                    nummes: mm.toString().trim().padStart(2, "0"),
                    descripcion: response.data[i].descripcion,
                    ubicacion: response.data[i].ubicacion,
                    iddeuda: response.data[i].idpublicidad,
                    //multa: response.data[i].multa,
                  });

                  break;
                case 1:
                  deu.push({
                    anio: response.data[i].anio,
                    mes: mes,
                    monto:
                      parseFloat(response.data[i].monto) *
                      parseFloat(factorCambio),
                    status: "Por Pagar",
                    nummes: mm.toString().trim().padStart(2, "0"),
                    descripcion: response.data[i].descripcion,
                    ubicacion: "",
                    iddeuda: response.data[i].idlicores,
                  });
                  break;
              }
            } else {
            }
            setDeuda(deu);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const procesarFactura = (body) => {
    let endpoint = `${op.conexion}/api/Caja_Ingreso/crearfactura`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        setActivate(false);
        if (response.status == 200) {
          valuess.idcontribuyente = "";
          valuess.rif = "";
          valuess.nombre = "";
          valuess.direccion = "";
          props.onHideAcepta();
          blanquear();
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const procesarpago = (body) => {
    let endpoint = `${op.conexion}/api/agenteweb/procesarpago`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto:
              "Estimado contribuyente, hacemos de su conocimiento que el procedimiento de verificación de pago tiene un tiempo estimado de 72 horas, una vez conciliado el mismo, será enviado vía correo electrónico, el correspondiente certificado de pago definitivo; valoramos y agradecemos su contribución para lograr el Municipio de lo Posible.",
            icono: "exito",
          });
          var idfactura = response.data.idfactu;
          var titulo =
            response.data.statusfac === 1
              ? "Certificado de Pago Electrónico"
              : "";
          var estatus = response.data.statusfac === 1 ? "'-2'" : "0";
          var certificado = response.data.statusfac === 1 ? "true" : "false";
          var tipo = response.data.tipotran === 1 ? "Depo" : "Trans";
          window.open(
            op.reportes +
              "FACTURA=" +
              idfactura +
              "&titulo=" +
              titulo +
              "&estatus=" +
              estatus +
              "&certificado=" +
              certificado +
              "&reporte=" +
              tipo,
            "Planilla",
            "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
          );
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const chandleCheckDeuda = (item, index) => (e) => {
    var deu = [...deuda];
    var montoseleccionado = 0.0;
    var montoFacturadoSelect = 0.0;
    var interesesSelect = 0.0;
    var multaSelect = 0.0;
    var recargoSelect = 0.0;
    var retenSelect = 0.0;
    var acrediSelect = 0.0;
    var per =
      props.tipo === 0 ? "PAGO DE PUBLICIDAD " : "PAGO DE TASA DE LICORES DE ";
    var periodofac = "";
    var seleccionados = 0;
    var periodo = "";
    var continua = true;

    if (chkSeleccionarDeuda.current[index].checked === true) {
      for (let i = 0; i < chkSeleccionarDeuda.current.length; i++) {
        if (i !== index) {
          chkSeleccionarDeuda.current[i].checked = false;
          deu[i].status = "Por Pagar";
        }
      }
      // periodo =
      //   " CORRESPONDIENTE AL PERIODO " + item.mes + " / " + item.anio + " ";
      periodo = " CORRESPONDIENTE AL Año " + item.anio;

      per =
        per +
        " " +
        item.descripcion.trim() +
        (item.ubicacion === "" || item.ubicacion === null
          ? ""
          : " UBICADO EN " + item.ubicacion.trim()) +
        periodo.toUpperCase();
      seleccionados = seleccionados + 1;
      periodofac = periodofac + item.nummes + " / " + item.anio + " ";
      montoseleccionado =
        parseFloat(montoseleccionado) + parseFloat(item.monto);
      montoseleccionado =
        Math.round(montoseleccionado * Math.pow(10, 2)) / Math.pow(10, 2);
      acrediSelect = parseFloat(acrediSelect) + parseFloat(item.credito);
      acrediSelect =
        Math.round(acrediSelect * Math.pow(10, 2)) / Math.pow(10, 2);
      montoFacturadoSelect =
        parseFloat(montoFacturadoSelect) + parseFloat(item.monto);
      montoFacturadoSelect =
        Math.round(montoFacturadoSelect * Math.pow(10, 2)) / Math.pow(10, 2);
      interesesSelect =
        parseFloat(interesesSelect) + parseFloat(item.intereses);
      interesesSelect =
        Math.round(interesesSelect * Math.pow(10, 2)) / Math.pow(10, 2);
      multaSelect = parseFloat(multaSelect) + parseFloat(item.multa);
      multaSelect = Math.round(multaSelect * Math.pow(10, 2)) / Math.pow(10, 2);
      recargoSelect = parseFloat(recargoSelect) + parseFloat(item.recargo);
      recargoSelect =
        Math.round(recargoSelect * Math.pow(10, 2)) / Math.pow(10, 2);
      retenSelect = parseFloat(retenSelect) + parseFloat(item.retenciones);
      retenSelect = Math.round(retenSelect * Math.pow(10, 2)) / Math.pow(10, 2);
    } else {
      per = "";
      seleccionados = 0;
      periodofac = "";
      montoseleccionado = 0.0;
      acrediSelect = 0.0;
      montoFacturadoSelect = 0.0;
      interesesSelect = 0.0;
      multaSelect = 0.0;
      recargoSelect = 0.0;
      retenSelect = 0.0;
    }

    if (item.status === "Por Pagar") {
      item.status = "Listo";
      setDisponiblesDeuda(disponiblesDeuda - 1);
    } else if (item.status === "Listo") {
      item.status = "Por Pagar";
    }
    setTotalSelect({
      concepto: per,
      seleccionados: seleccionados,
      montoseleccionado: formatMoneda(
        montoseleccionado.toString().replace(".", ","),
        ",",
        ".",
        2
      ),
      acrediSelect: formatMoneda(
        acrediSelect.toString().replace(".", ","),
        ",",
        ".",
        2
      ),
      montoFacturadoSelect: formatMoneda(
        montoFacturadoSelect.toString().replace(".", ","),
        ",",
        ".",
        2
      ),
      interesesSelect: formatMoneda(
        interesesSelect.toString().replace(".", ","),
        ",",
        ".",
        2
      ),
      multaSelect: formatMoneda(
        multaSelect.toString().replace(".", ","),
        ",",
        ".",
        2
      ),
      recargoSelect: formatMoneda(
        recargoSelect.toString().replace(".", ","),
        ",",
        ".",
        2
      ),
      retenSelect: formatMoneda(
        retenSelect.toString().replace(".", ","),
        ",",
        ".",
        2
      ),
    });

    if (seleccionados > 0) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
  };

  const procesarPagoWeb = () => {
    var nAnio = [];
    var nMes = [];
    var nMonto = [];
    var nInteres = [];
    var nMulta = [];
    var nRecargo = [];
    var nTotal = [];
    var cIdFact = [];
    var cNumPlani = [];
    var cPeri = [];
    var tdeu = [];
    var iddeu = [];
    var tipod = [];

    if (disabledMulta) {
      for (let i = 0; i < deuda.length; i++) {
        var sigue = deuda[i].status;
        if (sigue === "Listo") {
          nAnio.push(deuda[i].anio);
          nMes.push(deuda[i].nummes);
          nMonto.push(deuda[i].monto);
          nInteres.push(deuda[i].intereses);
          nMulta.push(deuda[i].multa);
          nRecargo.push(deuda[i].recargo);
          nTotal.push(deuda[i].totalperi);
          cIdFact.push(deuda[i].idfact);
          cNumPlani.push(deuda[i].planilla);
          cPeri.push(deuda[i].periodo);
          tdeu.push(deuda[i].tipodeuda);
          iddeu.push(parseInt(deuda[i].iddeu));
          tipod.push(deuda[i].tipod);
        }
      }
    } else {
      for (let i = 0; i < multa.length; i++) {
        var sigue = multa[i].status;
        if (sigue === "Listo") {
          nAnio.push(multa[i].anio);
          nMes.push(multa[i].nummes);
          nMonto.push(multa[i].monto);
          nInteres.push(multa[i].intereses);
          nMulta.push(multa[i].multa);
          nRecargo.push(multa[i].recargo);
          nTotal.push(multa[i].totalperi);
          cIdFact.push(multa[i].idfact);
          cNumPlani.push(multa[i].planilla);
          cPeri.push(multa[i].periodo);
          tdeu.push(multa[i].tipodeuda);
          iddeu.push(parseInt(multa[i].iddeu));
          tipod.push(multa[i].tipod);
        }
      }
    }

    var tipPago = tipoPago === "deposito" ? 1 : 2;

    var body = {
      idcontri: idcontribuyente,
      fechasis: fechaSistema,
      idimpu: tabla && tabla.idtipoimpuesto,
      mont: totalSelect.montoseleccionado.replace(/\./g, "").replace(",", "."),
      tipo: tipPago,
      cuenta: cuentasBanca,
      totaldescuento: "0.00",
      txtfecha1:
        fechaD1 === "" ? fechaD1 : moment.utc(fechaD1).format("YYYY-MM-DD"),
      txtnumdepo1: numeroD1,
      txtmontoefec1: efectivo1.replace(/\./g, "").replace(",", "."),
      txtfecha2:
        fechaD2 === "" ? fechaD2 : moment.utc(fechaD2).format("YYYY-MM-DD"),
      txtnumdepo2: numeroD2,
      txtmontoefec2: efectivo2.replace(/\./g, "").replace(",", "."),
      txtfechatran1:
        fechaT1 === "" ? fechaT1 : moment.utc(fechaT1).format("YYYY-MM-DD"),
      txtnumtran1: numeroT1,
      bcliente1: banCliT1,
      txtmontotran1: montoT1.replace(/\./g, "").replace(",", "."),
      txtfechatran2:
        fechaT2 === "" ? fechaT2 : moment.utc(fechaT2).format("YYYY-MM-DD"),
      txtnumtran2: numeroT2,
      bcliente2: banCliT2,
      txtmontotran2: montoT2.replace(/\./g, "").replace(",", "."),
      txtfechatran3:
        fechaT3 === "" ? fechaT3 : moment.utc(fechaT3).format("YYYY-MM-DD"),
      txtnumtran3: numeroT3,
      bcliente3: banCliT3,
      txtmontotran3: montoT3.replace(/\./g, "").replace(",", "."),
      ctotmonto: totalSelect.montoFacturadoSelect
        .replace(/\./g, "")
        .replace(",", "."),
      ctotint: totalSelect.interesesSelect.replace(/\./g, "").replace(",", "."),
      ctotrec: totalSelect.recargoSelect.replace(/\./g, "").replace(",", "."),
      ctotmulta: totalSelect.multaSelect.replace(/\./g, "").replace(",", "."),
      ctotrete: totalSelect.retenSelect.replace(/\./g, "").replace(",", "."),
      txtconcepto: totalSelect.concepto,
      panio: nAnio,
      pmes: nMes,
      pmonto: nMonto,
      pinteres: nInteres,
      pmulta: nMulta,
      precargo: nRecargo,
      ptotal: nTotal,
      tdeu,
      iddeu,
      tipod,
    };

    procesarpago(body);
  };

  const handleCloseSi = () => {
    procesarPagoWeb();
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };
  const blanquear = () => {
    setMulta([]);
    setDeuda([]);
    setDisponiblesDeuda(0);
    setBtnDisabled(true);
    setDisabledMulta(false);
    setCuentasBanca("0");
    setTipoPago("");
    setEfectivo1("0,00");
    setFechaD1("");
    setNumeroD1("");
    setEfectivo2("0,00");
    setFechaD2("");
    setNumeroD2("");
    setFechaT1("");
    setNumeroT1("");
    setBanCliT1("0");
    setMontoT1("0,00");
    setFechaT2("");
    setNumeroT2("");
    setBanCliT2("0");
    setMontoT2("0,00");
    setFechaT3("");
    setNumeroT3("");
    setBanCliT3("0");
    setMontoT3("0,00");
    setTotalSelect({
      concepto: "",
      seleccionados: "",
      montoseleccionado: "",
      acrediSelect: "",
      montoFacturadoSelect: "",
      interesesSelect: "",
      multaSelect: "",
      recargoSelect: "",
      retenSelect: "",
    });
  };
  const handleCatalogo = () => {
    switch (props.tipo) {
      case 0:
      case 1:
        if (!catalogoC) {
          setCatalogoC(true);
        } else {
          setCatalogoC(false);
        }
        break;

      default:
        break;
    }
  };

  const handleAceptaCatalogo = (id) => {
    switch (props.tipo) {
      case 0:
      case 1:
        setCatalogoC(false);
        break;
      default:
        break;
    }
    datosContribuyente(id);
  };

  const datosContribuyente = (idcontri) => {
    let nomid = "";
    let nomtab = "";
    let tipo = 1;
    setIdComercio(0);
    switch (props.tipo) {
      case 0:
        tipo = 1;
        nomid = "idcomercio";
        setNomTablaContri("comercio");
        setNomTablaDeuda("publicidad");
        break;
      case 1:
        tipo = 1;
        nomid = "idcomercio";
        setNomTablaContri("comercio");
        setNomTablaDeuda("licores");
        break;
    }

    let campos = "*";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idcontri}&nomtab=${nomTabla}&nomid=${nomid}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            switch (props.tipo) {
              case 0:
              case 1:
                txtContribuyente.current.value = response.data.idcomercio;
                valuess.rif = response.data.rif;
                valuess.nombre = response.data.nombre;
                valuess.direccion = response.data.direccion;
                SelectDeuda(
                  txtContribuyente.current.value,
                  fechaSistema,
                  espiritu
                );
                break;
            }
          } else {
            //if (teclas === 13) {
            setActivate(false);
            setTimeout(() => {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El Contribuyente no existe...",
                icono: "error",
              });
              txtContribuyente.current.value = "";
              valuess.rif = "";
              valuess.nombre = "";
              valuess.direccion = "";
              blanquear();
              txtContribuyente.current.focus();
            }, 100);
            //}
          }
        }

        //setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const validarContribuyente = (event) => {
    event.preventDefault();
    (valuess.idcontribuyente = event.target.value),
      (valuess.nombre = ""),
      (valuess.rif = ""),
      (valuess.direccion = "");
    setDeuda([]);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        datosContribuyente(event.target.value);
      } else {
        txtContribuyente.current.value = "";
      }
    }
  };

  const cancelar = (e) => {
    e.preventDefault();
    valuess.idcontribuyente = "";
    valuess.rif = "";
    valuess.nombre = "";
    valuess.direccion = "";
    props.onHideCancela();
    blanquear();
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var factu = [];
    var factudet = [];
    var anioDeu = parseInt(0);
    var idDeu = parseInt(0);

    for (let i = 0; i < deuda.length; i++) {
      if (deuda[i].status === "Listo") {
        anioDeu = deuda[i].anio;
        (idDeu = deuda[i].iddeuda),
          factudet.push({
            montoimpuesto: deuda[i].monto,
            montorecargo: deuda[i].recargo,
            montointeres: deuda[i].intereses,
            periodo: deuda[i].nummes + "/" + deuda[i].anio,
            montomulta: deuda[i].multa,
            montopetro: deuda[i].monto / factorCambio,
            tipodeuda: deuda[i].tipodeuda,
          });
      }
    }

    factu.push({
      //idcontribuyente: txtAgente.current.value,
      totalinmpuesto: totalSelect.montoFacturadoSelect
        .replace(/\./g, "")
        .replace(",", "."),
      totalrecargo: totalSelect.recargoSelect
        .replace(/\./g, "")
        .replace(",", "."),
      totalinteres: totalSelect.interesesSelect
        .replace(/\./g, "")
        .replace(",", "."),
      idtipoingreso: idTipIngre,
      fechaemision: fechaSistema,
      descripcion: totalSelect.concepto + " " + tipoImpu,
      tablacontribuyente: nomTablaContri,
      tabladeuda: nomTablaDeuda,
      iddeuda: idDeu,
      status: 0,
      nombrecontri: valuess.nombre,
      direccioncontri: valuess.direccion,
      cedrif: valuess.rif,
      totalmulta: totalSelect.multaSelect.replace(/\./g, "").replace(",", "."),
      deducible:
        parseFloat(
          totalSelect.retenSelect.replace(/\./g, "").replace(",", ".")
        ) +
        parseFloat(
          totalSelect.acrediSelect.replace(/\./g, "").replace(",", ".")
        ),
      facturador: idusuario,
      //totalfactura: totalSelect.montoFacturadoSelect.replace(/\./g, '').replace(',', '.'),
      idcomercio: idComercio,
    });

    let body = {
      idcontri: parseInt(txtContribuyente.current.value, 10),
      factu: JSON.stringify(factu),
      factudet: JSON.stringify(factudet),
      nomtab: nomTabla,
      tipoimpu: tipoImpu,
      idingremul: idTipIngreMulta,
    };

    procesarFactura(body);
    /*setDesde(0);
        let msg = 'Esta Seguro de Procesar la Declaración?.';
        setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });*/
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        switch (props.tipo) {
          case 0:
            setNomTabla("comercio");
            setTipoImpu("PROPAGANDA Y PUBLICIDAD COMERCIAL");
            break;
          case 1:
            setNomTabla("comercio");
            setTipoImpu("RENTAS DE LICORES");
            break;
        }
        seleccionartipoIngreso();
        seleccionartipoIngresoMulta();
        setFactorCambio(props.factorCambio);
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex align-items-center justify-content-between azulGradiant">
        <h3 className="m-0 fw-bold">{props.tipoImpuesto}</h3>
        <a type="button" className="fs-6 text-light fw-bold" onClick={cancelar}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <fieldset className="col-12 m-0 p-2 d-flex flex-wrap align-items-center justify-content-between border-azul rounded">
        <legend className="float-none m-0 w-auto">
            Datos del Contribuyente
        </legend>
        <div className="col-4 col-lg-3 m-0 p-0">
            <SearchInput label = "Código:"
                name="idcontribuyente"
                autoComplete="off"
                ref={txtContribuyente}
                defaultValue={valuess.idcontribuyente}
                onKeyUp={validarContribuyente}
                placeholder="Código"
                onChange={onChange}
                onClickButton = {handleCatalogo}
            />
        </div>
        <div className="col-12 col-lg-5 m-0 mt-2 mt-lg-0 p-0">
            <Input label = "Nombres:"
                disabled
                autoComplete="off"
                value={valuess.nombre}
                name="nombre"
            />
        </div>

        <div className="col-12 col-lg-3 m-0 mt-2 mt-lg-0 p-0">
            <Input label = "Cédula/Rif:"
                disabled
                autoComplete="off"
                value={valuess.rif}
                name="rif"
            />
        </div>

        <div className="col-12 m-0 mt-2 p-0">
            <Textarea label = 'Dirección:'
                style={{ height: 70 }}
                disabled
                autoComplete="off"
                value={valuess.direccion}
                name="direccion"
            />
        </div>
        </fieldset>
        <fieldset className="col-12 m-0 p-2 border-azul rounded">
        <legend className="float-none m-0 w-auto ">
            Datos de la Deuda
        </legend>
        <TblContainer
            container={{ maxHeight: 180, width: "100%", overflow: "auto" }}
        >
            <TblHead />
            <tbody>
            {deuda &&
                deuda.map((deu, index) => (
                <tr key={index}>
                    {deu.status === "Por Pagar" ? (
                    <td className="p-0 text-center letra-tabla-td">
                        <input
                        type="checkbox"
                        ref={(el) =>
                            (chkSeleccionarDeuda.current[index] = el)
                        }
                        defaultChecked={
                            deu.status === "Por Pagar" ? false : true
                        }
                        onClick={chandleCheckDeuda(deu, index)}
                        name={"chk" + deu.mes + deu.anio}
                        style={{ width: 20, height: 20 }}
                        />
                    </td>
                    ) : (
                    <td className="p-0 text-center letra-tabla-td">
                        <input
                        type="checkbox"
                        ref={(el) =>
                            (chkSeleccionarDeuda.current[index] = el)
                        }
                        defaultChecked={true}
                        name={"chk" + deu.mes + deu.anio}
                        onClick={chandleCheckDeuda(deu, index)}
                        style={{
                            width: 20,
                            height: 20,
                        }} 
                        />
                    </td>
                    )}
                    <td className="p-0 text-center letra-tabla-td">
                    {deu.anio}
                    </td>
                    <td className="p-0 text-center letra-tabla-td">
                    {deu.mes}
                    </td>
                    <td className="p-0 text-left letra-tabla-td">
                    {deu.descripcion.trim()}
                    </td>
                    <td className="p-0 text-left letra-tabla-td">
                    {deu.ubicacion === null ? "" : deu.ubicacion.trim()}
                    </td>
                    <td className="p-0 text-right letra-tabla-td">
                    {formatMoneda(
                        deu.monto
                        .toString()
                        .replace(",", "")
                        .replace(".", ","),
                        ",",
                        ".",
                        2
                    )}
                    </td>
                </tr>
                ))}
            </tbody>
        </TblContainer>
        <div className="col-12 p-0 m-0 my-2 d-flex align-items-center justify-content-between">
            <li className="col p-0 border p-2 d-flex justify-content-between">
            Facturado:
            <span>{totalSelect.montoFacturadoSelect}</span>
            </li>
            <li className="col p-0 border p-2 d-flex justify-content-between">
            Interespor Mora:
            <span>{totalSelect.interesesSelect}</span>
            </li>
            <li className="col p-0 border p-2 d-flex justify-content-between">
            Recargo por Mora:
            <span>{totalSelect.recargoSelect}</span>
            </li>
            <li className="col p-0 border p-2 fw-bold d-flex justify-content-between">
            Total:
            <span>{totalSelect.montoseleccionado}</span>
            </li>
        </div>
        <p className="col-12 m-0 p-2">
            <span className="fw-bold">Concepto: </span>
            {totalSelect.concepto}
        </p>
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          disabled={btnDisabled}
          onClick={onChangeValidar}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
          onClick={cancelar}
        >
            Cancelar
        </DangerButton>
      </Modal.Footer>

      <Dimmer active={activate} inverted></Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <CatalogoComercio
        titulo={titulo}
        mensaje={msg}
        show={catalogoC}
        onHideCancelaCatCom={handleCatalogo}
        onHideAceptaCatCom={handleAceptaCatalogo}
      />
    </Modal>
  );
};
